import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AbstractMixedStorageDataStore } from 'v2/data-store/abstract.mixed-storage-data-store';
import {
  MixedStorageStore,
  MixedStorageStoreHash,
} from 'v2/data-store/data-store.types';
import { State } from 'v2/data-store/state';
import { LocalStorageKeys } from 'v2/modules/shared';

export interface ISalesOrderViewSettingsState {
  agFilterModel :{ [key :string] :any };
  prefersFiltersOpen :boolean;
  prefersSidebarOpen :boolean;
  prefersTagsCollapsed :boolean;
}

@Injectable({
  providedIn: 'root',
})
export class SalesOrderViewSettingsService extends AbstractMixedStorageDataStore<
  ISalesOrderViewSettingsState,
  State<ISalesOrderViewSettingsState>
> {
  readonly state = new State<ISalesOrderViewSettingsState>({
    agFilterModel: null,
    prefersFiltersOpen: true,
    prefersTagsCollapsed: false,
    prefersSidebarOpen: true,
  });
  readonly state$ :Observable<ISalesOrderViewSettingsState> = this.state.$;
  readonly storageKey = LocalStorageKeys.SALES_ORDER_VIEW_SETTINGS;
  readonly storeHash :MixedStorageStoreHash<ISalesOrderViewSettingsState> = {
    '*': MixedStorageStore.LOCAL,
    agFilterModel: MixedStorageStore.SESSION,
  };

  constructor() {
    super();
    this.init();
  }
}
